import { inject } from '@angular/core';
import { Router, CanActivateFn, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { SessionMonitorService } from '../services/session-monitor.service';

/**
 * Modern functional route guard for authentication
 * Replaces class-based AuthGuardService
 */
export const authGuard: CanActivateFn = async (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const sessionMonitor = inject(SessionMonitorService);

  if (authService.isLogin()) {
    sessionMonitor.start();
    return true;
  }

  const refreshed = await authService.refreshCurrentToken();
  if (refreshed) {
    sessionMonitor.start();
    return true;
  }

  // Remember where they were headed so login can return them there. A shared QA result is
  // typically opened from a link in an email or chat, so dropping them on the dashboard after
  // login would lose the thing they actually clicked.
  router.navigate(['/Login'], { queryParams: { returnUrl: state.url } });
  return false;
};
